import { Component } from '@angular/core';
import { iBisBaseComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { GoogleMapsService } from '../../../service/google-maps.service';

@Component({
    selector: 'app-upload-excel',
    templateUrl: './upload-excel.component.html',
    styleUrls: ['./upload-excel.component.scss']
})
export class UploadExcelComponent extends iBisBaseComponent {

    isHovering = false;

    constructor(public proxy: ProxyService, public googleService: GoogleMapsService) {
        super(proxy.uploadExcel, proxy.lg, proxy.iui, proxy.activatedRoute);
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = 'copy'; // Show copy cursor
        }
        this.isHovering = true;
    }

    onDragLeave(event: DragEvent): void {
        event.preventDefault();
        this.isHovering = false;
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        this.isHovering = false;
        const file = event.dataTransfer?.files[0];
        if (file && this.proxy.uploadExcel.isExcel(file)) {
            this.proxy.uploadExcel.handleFile(file);
        }
    }

    onFileSelected(event: any): void {
        const file = event.target.files[0];
        if (file && this.proxy.uploadExcel.isExcel(file)) {
            this.proxy.uploadExcel.handleFile(file);
        }
    }





}
